module.exports = __webpack_public_path__ + "static/homemovie-f566d1f2be06afa28c2a36001087b805.mp4";